import {ApiUrls } from 'shared/config/model/urls';

import {createApi} from '@reduxjs/toolkit/query/react';

import httpBaseQuery from 'shared/api/rtk-query/httpBaseQuery';

import {ISupportRequest} from '../model/ISupport';


export const supportAPI = createApi({
    reducerPath: 'supportAPI',
    baseQuery: httpBaseQuery(),
    tagTypes: ['Support'],
    refetchOnMountOrArgChange: 60,
    refetchOnFocus: true,
    refetchOnReconnect: true,
    endpoints: (build) => ({
        addSupportMessage: build.mutation<string, ISupportRequest>({
            query: (data) => ({
                path: ApiUrls.SUPPORT_REQUEST,
                method: 'POST',
                data,
            }),
        }),
    }),
});